import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class OnOffButton extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', '.is-on-off-button', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let button = $(event.currentTarget),
        route = button.data('route');

    if (typeof route === 'undefined') {
      return false;
    }

    event.preventDefault();

    button.addClass('is-loading');

    return this.App.API.post(route, {}).catch((error) => {

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    }).then((response) => {

      if (response.data) {
        button.removeClass('is-on is-off').addClass('is-' + (response.data.is_active ? 'on' : 'off'));
        return true;
      }

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    }).finally(() => {
      button.removeClass('is-loading');
    });

  }

}